import styled from 'styled-components';

export const ModalContentContainer = styled.div`
  padding: 1em;
`;

export const ModalContentHeaderContainer = styled.div`
  margin-bottom: 20px;
`;
